import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Service } from './service';
import { ReferralData } from '../models/referral-data.model';

@Injectable({
  providedIn: 'root'
})
export class ReferralService extends Service {

  constructor(
    http: HttpClient
  ) {
    super(http);
  }

  fetch(referralUser: string, referralCampaign: string, referralUrl: string) {
    if (referralUser) {
      let params: any = {};
      if (referralUser) {
        referralCampaign = referralCampaign ?? '';
        params = { referralUser, referralCampaign, referralUrl };
      }
      this.http.post<ReferralData>(this.url + '/snack/v1/referralInit', params).subscribe(data => {
        if (data?.affiliateId) {
          this.set(data);
        }
      });
    }
  }

  set(value: ReferralData) {
    const now = new Date();
    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      value: value,
      expiry: now.getTime() + 86400000, // 24hs
    };
    localStorage.setItem('referral', JSON.stringify(item));
  }

  get(): ReferralData {
    const itemStr = localStorage.getItem('referral');
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem('referral');
      return null;
    }
    return item.value;
  }

}
